import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faPenToSquare, faUserPen } from "@fortawesome/free-solid-svg-icons";

import { EMPTY, formatCuit } from "../../crmpostventa-shared/crmFormat";
import RegistrarGestionMenu from "../../crmpostventa-ipc/components/RegistrarGestionMenu";
import { estadoTone } from "../fichaFormat";

export const NO_EDIT_TITLE = "Tu usuario solo puede ver la ficha";

const show = (value) => (value === null || value === undefined || String(value).trim() === "" ? EMPTY : String(value));

export function EstadoChip({ estado }) {
  return <span className={`crm-rollo__chip crm-rollo__chip--status crm-rollo__chip--${estadoTone(estado)}`}>{estado}</span>;
}

/**
 * Header of the Ficha (design Prompt 1, point 1): nombre de fantasía, CUIT, Estado, Terminal, Comercio and Legajo, with
 * "Editar datos" (primary), "Registrar gestión" (the IPC menu, as the old Ficha mounted it) and "Refrescar".
 * "Cambiar cliente" stays here because the Ficha has no other client selector (the page top bar is hidden).
 */
export default function FichaHeader({
  cabecera,
  clienteId,
  canEdit,
  busy,
  darkMode,
  editarButtonRef,
  onEditar,
  onRefrescar,
  onCambiarCliente,
  onNavigate,
}) {
  const header = cabecera || {};
  const estado = show(header.estado);

  return (
    <div className="crm-ficha__head">
      <div className="crm-ficha__head-main">
        <h3 id="crm-ficha-title" className="crm-rollo__title">
          {header.nombreDeFantasia || "Ficha del cliente"}
        </h3>
        <dl className="crm-ficha__facts">
          <div>
            <dt>CUIT</dt>
            <dd>{formatCuit(header.cuit)}</dd>
          </div>
          <div>
            <dt>Estado</dt>
            <dd>{estado === EMPTY ? EMPTY : <EstadoChip estado={estado} />}</dd>
          </div>
          <div>
            <dt>Terminal</dt>
            <dd>{show(header.nDeTerminal)}</dd>
          </div>
          <div>
            <dt>Comercio</dt>
            <dd>{show(header.nDeComercio)}</dd>
          </div>
          <div>
            <dt>Legajo</dt>
            <dd>{show(header.legajo)}</dd>
          </div>
        </dl>
      </div>

      <div className="crm-ficha__actions">
        <button
          type="button"
          ref={editarButtonRef}
          className="crm-rollo__btn crm-rollo__btn--primary"
          disabled={busy || !canEdit}
          title={canEdit ? undefined : NO_EDIT_TITLE}
          onClick={() => onEditar?.()}
        >
          <FontAwesomeIcon icon={faPenToSquare} aria-hidden="true" />
          Editar datos
        </button>
        <RegistrarGestionMenu clienteId={clienteId} numeroTerminal={header.nDeTerminal} darkMode={darkMode} onNavigate={onNavigate} />
        <button type="button" className="crm-rollo__btn crm-rollo__btn--ghost" disabled={busy} onClick={onRefrescar}>
          <FontAwesomeIcon icon={faArrowsRotate} aria-hidden="true" />
          Refrescar
        </button>
        {onCambiarCliente ? (
          <button type="button" className="crm-rollo__btn crm-rollo__btn--ghost" onClick={onCambiarCliente}>
            <FontAwesomeIcon icon={faUserPen} aria-hidden="true" />
            Cambiar cliente
          </button>
        ) : null}
      </div>
    </div>
  );
}
